<template>
    <team-report-wrapper :loaded="loaded" :error="error" :key="loadedLanguage">
        <psi-team org :type="reportType" />
    </team-report-wrapper>
</template>
<script src="./TeamPsiOrganization.ts"></script>
